export default {
  /**
   * 各種メニューの表示状態
   */
  state() {
    return {
      /**
       * カテゴリメニュー
       */
      categoryMenu: false,
      /**
       * スライドメニュー
       */
      slideMenu: false
    };
  },
  getters: {
    /**
     * カテゴリメニュー状態の取得
     * @param {} state
     * @returns {Boolean}
     */
    getCategoryMenu(state) {
      return state.categoryMenu;
    },
    /**
     * スライドメニュー状態の取得
     * @param {} state
     * @returns {Boolean}
     */
    getSlideMenu(state) {
      return state.slideMenu;
    }
  },
  mutations: {
    /**
     * カテゴリメニュー状態の保存
     * @param {*} state
     * @param {Boolean} status
     */
    setCategoryMenu(state, status) {
      state.categoryMenu = status;
    },
    /**
     * スライドメニュー状態の保存
     * @param {*} state
     * @param {Boolean} status
     */
    setSlideMenu(state, status) {
      state.slideMenu = status;
    }
  }
};
